export default __webpack_public_path__ + "static/media/kitchen5-afterB-2048w.6946abbb.png";